import { render } from "./SurgeryIndex.vue?vue&type=template&id=b62fddaa"
import script from "./SurgeryIndex.vue?vue&type=script&lang=js"
export * from "./SurgeryIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__